import styled from "styled-components";

export const Main = styled.main``;
export const SummaryList = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(425px, 1fr));
  gap: 3rem;
  margin: auto;
  padding: 4rem;
  max-width: 1400px;
  align-items: center;
  justify-content: center;
`;
